<template>
  <div>
    <el-row>
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-checkbox v-model="radio" @change="changeRadioAction">{{ checkBoxMsg }}</el-checkbox>
        </el-form-item>
        <el-form-item label="选择时间类型">
          <el-select v-model="formInline.dateType" placeholder="选择时间类型" style="width: 120px">
            <el-option
              v-for="item in dateOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年份" v-if="formInline.dateType=='year'">
          <el-date-picker v-model="formInline.year" type="year" style="width:150px" value-format="yyyy"
                          placeholder="选择年份">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="开始时间" v-if="formInline.dateType=='range'">
          <el-date-picker v-model="formInline.startTime" type="month" style="width:150px" value-format="yyyy-MM"
                          placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" v-if="formInline.dateType=='range'">
          <el-date-picker v-model="formInline.endTime" type="month" style="width:150px" value-format="yyyy-MM"
                          placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toColumnPage">自定义表头</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toExport">导出</el-button>
        </el-form-item>

      </el-form>
    </el-row>
    <div style="height: calc(100vh - 270px);">
      <vxe-grid
        border
        resizable
        auto-resize
        show-footer
        id="annualAverage"
        align="center"
        width="100%"
        show-overflow
        ref="xGrid"
        height="100%"
        :footer-method="footerMethod"
        :custom-config="{storage: true}"
        :loading="loading"
        :columns="tableColumn"
        :data.sync="tableData"

      >
        <template v-slot:empty>
          <span>
            <svg class="icon icon-kong" aria-hidden="true" style="font-size: 40px;color: #999">
                  <use xlink:href="#icon-kong"></use>
                </svg>
            <p class="noData">暂无数据</p>
          </span>
        </template>
      </vxe-grid>
    </div>
    <vxe-pager
      :loading="loading"
      :current-page="formInline.page"
      :page-size="formInline.limit"
      :total="formInline.total"
      :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
      @page-change="handlePageChange">
    </vxe-pager>

    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="dialogheaderVisible"
    >
      <customHeader :headerList.sync="headerList" v-if="dialogheaderVisible" :headerData.sync="headerData"
      >

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveCusHeader()"
        >
          确认
        </el-button>
        <el-button @click="dialogheaderVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import customHeader from "@/wage-components/ciic-custom-table-header/index";
import {addWageSalaryAverageColumns, getSalaryWageAverageList, getWageAverageColumnsList} from "@/api/report/report.js";
import {bspTableFilter} from "../../../../filters";
import {mapGetters} from "vuex";
import XEUtils from 'xe-utils';
import exportMethod from '@/util/export.js'
import {deepCopy} from '@/util/util';

export default {
  components: {customHeader},
  created() {
    this._getWageAverageColumnsList({});
    this._getSalaryWageAverageList(this.formInline);
  },
  computed: {
    ...mapGetters([
      'dicts',
    ]),
  },
  methods: {
    handlePageChange({currentPage, pageSize}) {
      this.formInline.page = currentPage;
      this.formInline.limit = pageSize;
      this._getSalaryWageAverageList(this.formInline);
    },
    //重置
    resetAction() {
      this.hidden = false;
      this.$refs.xGrid.resetColumn();
    },
    changeRadioAction() {
      if (this.radio) {
        this.hiddenAction();//隐藏
        //this.checkBoxMsg='重置';
      } else {
        this.resetAction();//重置
        //this.checkBoxMsg='隐藏空列';
      }
    },
    //隐藏
    hiddenAction() {
      this.expHiddenColumns = []; // 清空
      if (this.hiddenColumns && this.hiddenColumns.length > 0) {
        this.hidden = true;
        // 先收集所有需要隐藏的列对象
        const allCols = [];
        this.tableColumn.forEach(col => {
          // 检查自身field
          if (col.field && !this.hiddenColumns.includes(col.field)) {
            allCols.push(col);
          }
          // 检查分组列
          if (col.grounpColumns && Array.isArray(col.grounpColumns)) {
            const hasChild = col.grounpColumns.some(sub => !this.hiddenColumns.includes(sub.field));
            if (hasChild) {
              allCols.push(col);
            }
          }
        });
        // 去重
        this.expHiddenColumns = [...new Set(allCols)];
        // 然后执行隐藏操作，遍历hiddenColumns
        this.hiddenColumns.forEach(filed => {
          this.$refs.xGrid.hideColumn(this.$refs.xGrid.getColumnByField(filed));
        });
      }
    },
    footerMethod({columns, data}) {
      this.hiddenColumns = [];

      const result = [
        columns.map((column, columnIndex) => {

          if (data && data.length > 0) {
            let columFiled = column.property;
            let result = XEUtils.every(data, (data) => {
              return data[columFiled] === 0 || data[columFiled] === null
                || data[columFiled] === '0' || data[columFiled] === '0.0' || data[columFiled] === '0.00'
            })
            if (result) {
              this.hiddenColumns.push(columFiled)
            }
          }

          if (columnIndex === 3) {
            return '合计'
          }
          if (this.sumListCode.includes(column.property)) {
            return XEUtils.sum(data, column.property)
          }
          return null
        })
      ]

      this.$nextTick(() => {
        if (this.radio) {
          this.hiddenAction();
        }
      });
      return result;
    },
    _getWageAverageColumnsList(obj) {
      getWageAverageColumnsList(obj).then(res => {
        this.headerData = res.data.checkLists;
        this.headerList = res.data.itemDatas.length > 0 ? res.data.itemDatas : res.data.sysLists;
        this.sumListCode = res.data.sumListCode;
        debugger;
        let records = res.data.itemDatas.length > 0 ? res.data.itemDatas : res.data.sysLists;
        let columns = records.map(column => {
          column.title = column.itemNameCh;
          column.field = column.field;
          if (column.isFixed == '10010001') {
            column.fixed = 'left';
          }
          column.minWidth = 100;
          return column
        });
        /*          columns.unshift({ title:'计税类型', field:'taxType',dataType:'dict',setid:'9245',width: 100 ,fixed:'left' });
                  columns.unshift({ title:'证件类型', field:'idCardType',dataType:'dict',setid:'3159',width: 100,fixed:'left'  });
                  columns.unshift({ title:'雇员姓名', field:'empName',width: 100,fixed:'left'  });*/
        columns.unshift({title: '序号', type: 'seq', width: 50, fixed: 'left'});
        this.tableColumn = columns;
      })
    },
    _getSalaryWageAverageList(obj) {
      getSalaryWageAverageList(obj).then(res => {
        this.tableData = res.data.records;
        for (let i = 0; i < res.data.records.length; i++) {
          let taxType = bspTableFilter(res.data.records[i].taxType, {'1': 'dict', 2: this.dicts})
          let idCardType = bspTableFilter(res.data.records[i].idCardType, {'1': 'dict', 2: this.dicts})
          this.$set(this.tableData[i], 'idCardType', idCardType)
          this.$set(this.tableData[i], 'taxType', taxType)

        }
        this.formInline.total = res.data.total;
        this.$nextTick(() => {
          if (this.radio) {
            this.hiddenAction();
          }
        });
      })
    },
    //跳转自定义表头设置
    toColumnPage() {
      this.dialogheaderVisible = true
    },
    saveCusHeader() {
      addWageSalaryAverageColumns({entityList: this.headerList}).then(res => {
        this.dialogheaderVisible = false;
        this._getWageAverageColumnsList({});
        this._getSalaryWageAverageList(this.formInline);
      })
    },
    onSearch() {
      if (this.formInline.monthType) {
        this._getSalaryWageAverageList(this.formInline);

      } else {
        this.$message.error('请选择统计日期类型');

      }

    },
    toExport() {
      let cols = [];
      if (this.radio && this.expHiddenColumns && this.expHiddenColumns.length > 0) {
        cols = this.$clone(this.expHiddenColumns);
      } else {
        cols = this.$clone(this.tableColumn);
      }
      let column = deepCopy(cols);
      column.splice(0, 1);
      exportMethod(
        {
          columns: column,
          type: "excel",
          beanName: "reportServiceImpl",
          methodName: "getSalaryWageAverageList",
          year: this.formInline.year,
          queryType: this.formInline.queryType,
          startTime: this.formInline.startTime,
          endTime: this.formInline.endTime,
          monthType: this.formInline.monthType,
          dateType: this.formInline.dateType,
          limit: this.formInline.limit,
          isHidden: this.radio,
          page: this.formInline.page,
          fileName: "年度平均工资汇总.xls",
        },
        "/wage", true
      );
    },
  },
  data() {
    return {
      sumListCode: [],//需要合计的列
      dialogheaderVisible: false,
      radio: false,
      checkBoxMsg: '隐藏空列',
      formInline: {
        queryType: 'COST_CENTER',
        startTime: '',
        endTime: '',
        monthType: '2',
        limit: 20,
        page: 1,
        total: 0,
        dateType: 'year',
      },
      dateOptions: [
        {
          value: 'year',
          label: '年份'
        }, {
          value: 'range',
          label: '时间区间'
        }
      ],
      headerList: [],
      tableColumn: [],
      hiddenColumns: [],//需要隐藏的列
      expHiddenColumns: [],//需要隐藏的列
      headerData: [],
      tableData: []
    }
  },
}
</script>
<style scoped>
.downLoad,
.del {
  font-size: 12px;
  margin-left: 20px;
  font-weight: 500;
  color: rgba(64, 158, 255, 1);
  line-height: 17px;
  cursor: pointer;
}

.fileName {
  padding-bottom: 10px;
  line-height: 17px;
}

.fileName img,
.fileName span {
  vertical-align: middle;
}

.fileName span {
  height: 17px;
  line-height: 17px;
}

.fileName span.oneOwner {
  padding-left: 42px;
}

.fileName img {
  margin-right: 20px;
}

.fileName:nth-last-of-type(1) {
  padding-bottom: 0;
}

.el-row {
  text-align: right;
  margin-bottom: 10px;
}

.upload {
  font-size: 12px;
  margin-right: 50px;
  font-weight: 500;
  color: rgba(64, 158, 255, 1);
  line-height: 17px;
}

.el-form--inline >>> .el-form-item {
  margin-bottom: 0;
}
</style>
